




































































































































import { Vue, Component, Ref, Prop, Watch} from 'vue-property-decorator'
import { SaveTituloUseCase } from '@/usecases/titulos'
import DatePicker from '@/components/ui/DatePicker.vue'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { FluxoDoTitulo, FormaDePagamento, FormDeTitulo, SituacaoDoTitulo, TipoDePessoa, Titulo } from '@/models'
import { obrigatorio } from '@/shareds/regras-de-form'
import CampoDecimal from '@/components/ui/CampoDecimal.vue'
import SeletorDePessoa  from '@/components/cliente/SeletorDePessoa.vue'
import SeletorDeLojas from '@/components/loja/SeletorDeLojas.vue'
import { criarTitulo } from '@/shareds/titulo'

@Component({
	components: {
		DatePicker,
		CampoDecimal,
		SeletorDePessoa,
		SeletorDeLojas,
	},
})
export default class DialogoDeEdicaoDeTitulo extends Vue {
	@Prop() tipoDePessoa!: TipoDePessoa
	@Ref() form!: HTMLFormElement
	@Ref() campoDeLoja!: HTMLInputElement
	formulario: FormDeTitulo = criarTitulo('Entrada')
	@Prop() titulo!: Titulo

	obrigatorio = obrigatorio

	condicao: string | null = null

	opcoesDeSituacaoDeTitulo: SituacaoDoTitulo[] = ['Aberto', 'Pago', 'Cancelado', 'Estornado']

	opcoesDeFormaDePagamento: FormaDePagamento[] = ['Dinheiro','Cartão','Voucher','TEF Crédito','TEF Débito','Outros']

	buscando = false
	mostra = false

	edicaoFormaPagamento = true

	saveTituloUseCase = new SaveTituloUseCase()

	titulos: Titulo[] = []

	get titulosFormatados() {
		return this.titulos.map(titulo => ({
			...titulo,
			formaDePagamento: titulo.formaDePagamento ? titulo.formaDePagamento : '',
		}))
	}

	mostrarDialogo(titulo: Titulo | FluxoDoTitulo, condicao: string) {		
		this.edicaoFormaPagamento = condicao == 'criar'
			? false
			: true 

		this.mostra = true
		this.formulario = typeof titulo === 'string'
			? criarTitulo(titulo)
			: { ...titulo,
				formaDePagamento: titulo.formaDePagamento ? this.displayPagamento(titulo.formaDePagamento) : '',
			}
		setTimeout(() => {
			this.campoDeLoja.focus()
		}, 250)
	}

	displayPagamento(formaDePagamento: string) {
		let formaFormatada
		if(formaDePagamento == 'CARTAO') formaFormatada = 'Cartão'
		if(formaDePagamento == 'DINHEIRO') formaFormatada = 'Dinheiro'
		if(formaDePagamento == 'VOUCHER') formaFormatada = 'Voucher'
		if(formaDePagamento == 'OUTROS') formaFormatada = 'Outros'
		if(formaDePagamento == 'TEF CREDITO') formaFormatada = 'TEF Crédito'
		if(formaDePagamento == 'TEF DEBITO') formaFormatada = 'TEF Débito'
		if(formaDePagamento == 'CREDIARIO') formaFormatada = 'Crediario'
		return formaFormatada
	}

	async salvarTitulo() {
		try {
			if (!this.form.validate()) return
			if (!this.formulario) return

			const titulo = await this.saveTituloUseCase.execute(this.formulario)

			this.$emit('salvar', titulo)
			this.mostra = false
		} catch (e) {
			AlertModule.setError(e)
		}
	}

	@Watch('mostra')
	onChangeMostra(mostra: boolean) {
		if (!mostra) return
		
		window.requestAnimationFrame(() => {
			this.form.resetValidation()
		})
	}
}
